module.exports = __webpack_public_path__ + "img/document-accept-2.4158a1ff.svg";